import ROLE from "models/role";
import { MANAGER_ROUTES } from "definitions/constants/routeConstants";
import ManagerDashboardPage from "pages/Manager/DashboardPage";
import ManagerNewHirePage from "pages/Manager/NewHirePage";
import { Route } from "./types";

const MANAGER_ROUTES_PERMISSIONS = {
  permission: [ROLE.MANAGER],
};

export const MANAGER_DASHBOARD_ROUTE: Route = {
  path: MANAGER_ROUTES.dashboard,
  title: "Manager Dashboard",
  component: <ManagerDashboardPage />,
  ...MANAGER_ROUTES_PERMISSIONS,
};

export const MANAGER_NEW_HIRE_ROUTE: Route = {
  path: "/manager/new-hires/:id/*",
  title: "New Hire Detail",
  component: <ManagerNewHirePage />,
  ...MANAGER_ROUTES_PERMISSIONS,
};

export default [
  MANAGER_DASHBOARD_ROUTE,
  MANAGER_NEW_HIRE_ROUTE,
];